export enum PageBackgroundDropDownItem {
  SOLID = 'solid',
  GRADIENT = 'gradient',
  LINEAR_GRADIENT = 'linear_gradient',
  RADIAL_GRADIENT = 'radial_gradient',
  TRANSPARENT = 'transparent',
  MY_BACKGROUNDS = 'my_backgrounds',
  MY_IMAGES = 'my_images',
  STOCK_IMAGE = 'stock_image',
  MY_VIDEOS = 'my_videos',
  STOCK_VIDEO = 'stock_video',
}
